<template>
	<section class="portfolio-overview">
		<div class="max-width-1000">
			<quote-title label="系列作品" />
			<br>
			<div class="row-grid" gutter-x="20" gutter-y="10" align-x="center">
				<div v-for="(item, i) in typeList" :key="item + i">
					<radio v-model="currentType" :id="item + i" :value="item" />
				</div>
			</div>
			<br>
			<br>
			<transition name="fade" mode="out-in">
				<div v-if="fadeVisible" class="row-grid" gutter-x="30" gutter-y="20">
					<template v-for="(item, i) in list">
						<router-link :to="`/portfolio/${item.id}`" class="col rwd-l-3 rwd-m-4 rwd-s-6" :key="item.id || i">
							<thumb :src="item.thumb" />
							<br>
							<div class="col" gutter="10">
								<p style="text-align:center;">{{item.title}}</p>
								<small style="text-align:center;">{{item.sub_title}}</small>
							</div>
							<br>
						</router-link>
					</template>
				</div>
			</transition>
			<br>
		</div>
	</section>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
	components: {
		Thumb: () => import("@/components/thumb"),
		Radio: () => import("@/components/radio"),
	},
	data() {
		return {
			fadeVisible: true,
			currentType: ""
		}
	},
	computed: {
		...mapState("portfolio", ["_portfolioList"]),
		typeList() {
			return this._portfolioList
				.reduce((a, { type }) => type && a.includes(type) ? a : a.concat(type), new Array);
		},
		list() {
			return this._portfolioList.filter(({ type }) => type == this.currentType);
		}
	},
	watch: {
		currentType(val) {
			this.fadeVisible = false;
			setTimeout(() => (this.fadeVisible = true), 300);
		}
	},
	methods: {
		...mapActions("portfolio", ["_getList"]),
	},
	async created() {
		if (!this._portfolioList.length) await this._getList();
		const { type } = this._portfolioList
			.find(({ type }) => type) || new Object;
		this.currentType = type || "";
	}
}
</script>

<style lang="scss" scoped>
.portfolio-overview {
	padding: 50px 5%;
	position: relative;
	background-size: 100%, 100%, 410px;
	background-repeat: no-repeat;
	background-image: url("../../../assets/background/brush3.png"),
		url("../../../assets/background/dot5.png"),
		url("../../../assets/background/flower1.png");
	background-position: center bottom, center 80%, 85% 90%;

	@media screen and (max-width: 768px) {
		background-size: 100%, 100%, 300px;
	}

	@media screen and (max-width: 425px) {
		background-size: 100%, 100%, 0;
	}
}
</style>